/**
 * Feature Flag Keys
 * Centralized location for all LaunchDarkly feature flag keys used in the application.
 */
export const FEATURE_FLAGS = {
    ENABLE_LONG_TERM_SELL_ORDER: 'enableLongTermSellOrder',
    USE_CLIENT_MASTER: 'useClientMaster',
} as const;

export type FeatureFlagKey = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];
